/* eslint-disable max-len */
import Vue from 'vue';
import _ from 'lodash';

const importTemplate = {
  state: 'active',
  dynamic: false,
  error: null,
  warmProcessed: false,
  hotProcessed: false,
  hotProgress: {
    count: 0,
    target: 0,
  },
  hotProcessingProgress: {
    count: 0,
    target: 0,
  },
};

const progress = { count: 0, target: 0 };
const addImport = (state, payload) => {
  Vue.set(state.imports, payload, _.cloneDeep(importTemplate));
  Vue.set(state, 'lastImport', payload);
};

export default {
  state: {
    imports: {},
    lastImport: null,
  },
  getters: {
    imports: state => state.imports,
    currentImport: state => state.lastImport && state.imports[state.lastImport] && state.imports[state.lastImport].state === 'active' ? state.imports[state.lastImport] : null,
    hotDataIsLoading: (state, getters) => getters.currentImport && !getters.currentImport.hotProcessed,
    warmDataIsLoading: (state, getters) => getters.currentImport && !getters.currentImport.warmProcessed,
    importProgress: (state, getters) => (getters.currentImport || {}).hotProgress || progress,
    processingProgress: (state, getters) => (getters.currentImport || {}).hotProcessingProgress || progress,
  },
  mutations: {
    clearDataImports(state) {
      state.imports = {};
      Vue.set(state, 'lastImport', null);
    },
    addImport(state, payload) {
      addImport(state, payload);
    },
    setProcessed(state, payload) {
      Vue.set(state.imports[payload.id], `${payload.temperature}Processed`, true);
      if (payload.temperature === 'warm') {
        Vue.set(state.imports[payload.id], 'state', 'complete');
        Vue.set(state, 'lastImport', null);
      }
    },
    setImportProgress(state, payload) {
      if (!state.imports[payload.id]) {
        addImport(state, payload.id);
      }
      if (payload.target >= state.imports[payload.id].hotProgress.target
          && payload.count >= state.imports[payload.id].hotProgress.count) {
        Vue.set(state.imports[payload.id].hotProgress, 'target', payload.target);
        Vue.set(state.imports[payload.id].hotProgress, 'count', payload.count);
      }
    },
    setProcessingProgress(state, payload) {
      if (!state.imports[payload.id]) {
        addImport(state, payload.id);
      }
      if (payload.target >= state.imports[payload.id].hotProcessingProgress.target
          && payload.count >= state.imports[payload.id].hotProcessingProgress.count) {
        Vue.set(state.imports[payload.id].hotProcessingProgress, 'target', payload.target);
        Vue.set(state.imports[payload.id].hotProcessingProgress, 'count', payload.count);
      }
    },
    setError(state, payload) {
      if (state.imports[payload.id]) {
        state.imports[payload.id].error = payload.error;
        state.imports[payload.id].state = 'error';
      }
    },
  },
  actions: {
    clearDataImports(context) {
      context.commit('clearDataImports');
    },
    addImport(context, payload) {
      context.commit('addImport', payload);
    },
    setError(context, payload) {
      context.commit('setError', payload);
    },
    setProcessed(context, payload) {
      context.commit('setProcessed', payload);
    },
  },
};
